export default "__VITE_ASSET__CvFDF2I7__"